module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.14.0.0.box.557.856.938.118.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.14.0.0.box.557.856.938.118.q.90"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.1.0.box.281.1494.1495.641.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.14.1.0.box.281.1494.1495.641.q.60"
    }
  }, [_vm._v("M"), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("any")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("thanks")]), _vm._v(" to Peggy Scott Laborde of WYES-TV for sharing information and suggesting sources for pictures. Thanks to Marion A. Lanasa, Jr., Director of Public Affairs, Lockheed Martin for information about the space program and the photo of the Saturn rocket booster. Thanks to Wayne "), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.0.0"
    }
  }), _vm._v("Everard at the New Orleans Public Library, Sally Stassi at the Historic New Orleans Collection, Nancy Burris at the Times Picayune Publishing Company, and Florence Jumonville at the Earl K. Long Library, and a special thanks to reference librarian Pamela Arceneaux at the Williams Research Center, for last-minute r"), _c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _vm._v("esearch. Thanks to William E. Borah, attorney, for slides and to Curtis and Davis, architects, for photos. Thanks to the Marianite sisters for pictures from their year-books. Thanks to photographers Tracy Clouatre and Michael P. Smith. And to my many friends who loaned me pictures from their personal collections.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.0.0.box.884.860.604.704.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "174%",
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.16.0.0.box.884.860.604.704.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _vm._v("New Orleans in the SIXTIES")]), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.3.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.17.0.0.box.0.102.2407.2847.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0007.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9676f42e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0008.vue
// module id = 63
// module chunks = 0